import { useEffect, useRef } from 'react';

// Implementation that claims to be according to
// Dan Abmarov in https://overreacted.io/making-setinterval-declarative-with-react-hooks/

export function useTimeout(callback: () => undefined, delay: number | null) {
  const savedCallback = useRef<() => undefined>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      const id = setTimeout(tick, delay);
      return () => {
        clearTimeout(id);
      };
    }
    return undefined;
  }, [delay]);
}
